export default "__VITE_ASSET__63bf431e__"